<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Digital Marketing</h2>
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="service-details-content">
            <div class="row">
                <div class="col-lg-5 col-md-6 col-sm-12 col-12">
                    <div class="service-details-image">
                        <img src="assets/img/services-image/why_choose_us_right_img_2.jpeg" class="w-100" alt="image">
                    </div>
                </div>
                <div class="col-lg-7 col-md-6 col-sm-12 col-12">
                    <h3>Digital Marketing</h3>
                    <p>
                        We provides you with the complete Digital Marketing services. It includes email and content
                        marketing, search engine marketing, content marketing & many more awesome services. We also
                        increase improvement Up to 1000 times in website traffic, visitors, & sources.
                    </p>
                    <p>
                        Kaims IT Services collaborates with you to develop bespoke digital marketing services and a plan that
                        meets your custom requirements. A dedicated digital marketing company and a partner that
                        understands markets and goals. Rather than an ordinary digital marketing agency that executes
                        strategies blindly, we focus on marketing strategies that result in actual growth.
                        Kaims IT Services understands technology & when it is combined with traditional marketing & digital
                        marketing, the results are definitely worth it. Our strategic marketing campaigns focus on
                        Content Marketing, Email Marketing, Pay Per Click PPC and Web Design. Our online marketing team
                        is well-versed in search engine optimization SEO & social media marketing that drives engagement
                        across all digital platforms.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="features-card-section pt-100 pb-70 bg-f8fbfa">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-12 col-sm-12 text-center">
                <div class="icon mb-4">
                    <img src="assets/img/favicon.png" class="fav-size" alt="image">
                </div>
                <h2 class="mb-4">
                    <strong>Why Choose Kaims IT For SEO Services?</strong>
                </h2>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-3 col-sm-6 col-md-6 mb-4">
                <div class="single-features-card h-100 mb-0 tx-center">
                    <i class='bx bx-code-alt'></i>
                    <h3><a>Dedicated Support</a></h3>
                    <p>
                        Quick Turn-Around And Dedicated Support By 100% In-House Team
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 mb-4">
                <div class="single-features-card h-100 mb-0 tx-center">
                    <i class='bx bxs-star' ></i>
                    <h3><a>Top-Rated Company</a></h3>
                    <p>
                        Hundreds Of Real Reviews On Google And Top Developer Forums
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 mb-4">
                <div class="single-features-card h-100 mb-0 tx-center">
                    <i class='bx bx-user-voice'></i>
                    <h3><a>Hire Experts</a></h3>
                    <p>
                        We Provide Pre-Vetted Qualified Engineers For Your Projects
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 mb-4">
                <div class="single-features-card h-100 mb-0 tx-center">
                    <i class='bx bx-building-house' ></i>
                    <h3><a>Modern Infrastructure</a></h3>
                    <p>
                        We Have The Best Workplace With Modern Infrastructure In The City
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 mb-4">
                <div class="single-features-card h-100 mb-0 tx-center">
                    <i class='bx bx-support' ></i>
                    <h3><a>Local Support</a></h3>
                    <p>
                        Get Local Support From Our Consultants In India
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 mb-4">
                <div class="single-features-card h-100 mb-0 tx-center">
                    <i class='bx bxs-discount'></i>
                    <h3><a>Save Up-To 60%</a></h3>
                    <p>
                        Optimize Development Costs By More Than 50% And Increase The ROI
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <section class="subscribe-area bg-f4f5fe">
    <div class="container">
        <div class="subscribe-content">
            <h2>We always try to be the best support to you as possible</h2>
            <form class="newsletter-form">
                <div class="row align-items-center">
                    <div class="col-lg-8 col-md-8">
                        <input type="email" class="input-newsletter" placeholder="hello&#64;jexsa.com" name="EMAIL"
                            required>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <button type="submit"><i class="bx bxs-hot"></i> Subscribe Now</button>
                    </div>
                </div>
            </form>
            <div class="shape14"><img src="assets/img/shape/shape13.png" alt="image"></div>
            <div class="shape15"><img src="assets/img/shape/shape14.png" alt="image"></div>
            <div class="shape16"><img src="assets/img/shape/shape15.png" alt="image"></div>
            <div class="shape17"><img src="assets/img/shape/shape16.png" alt="image"></div>
            <div class="shape18"><img src="assets/img/shape/shape17.png" alt="image"></div>
        </div>
    </div>
</section> -->

<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>We always try to be the best support to you as possible</h2>
            <p>Qualify your leads & recognize the value of word your customer will love you</p>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot"></i> Contact Us<span></span></a>
        </div>
    </div>
    <div class="shape10"><img src="assets/img/shape/shape10.png" alt="image"></div>
    <div class="shape11"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape12"><img src="assets/img/shape/shape11.png" alt="image"></div>
    <div class="shape13"><img src="assets/img/shape/shape12.png" alt="image"></div>
</section>